
export default {
    namespaced: true,
    state: {
        tableData: [],
        chartDictionaryData: {},
        chartImportData: {},
        chartProductData: {},
        chartBrandData: {},
        chartCategoryData: {},
        chartRuQueryData: {},
        chartWwQueryData: {},
        users: [],
        currentUser: null,
        showType: 'day',
        currentPage: 1,
        totalRows: null,
        perPage: 10,
        sortField: 'date',
        sortDir: 'desc',

    },
    getters: {
        SORT_FIELD: state => {
            return state.sortField;
        },
        SORT_DIR: state => {
            return state.sortDir;
        },
        USERS: state => {
            return state.users;
        },
        CURRENT_USER: state => {
            return state.currentUser;
        },
        SHOW_TYPE: state => {
            return state.showType;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        },
        CHART_DICTIONARY_DATA: state => {
            return state.chartDictionaryData;
        },
        CHART_IMPORT_DATA: state => {
            return state.chartImportData;
        },
        CHART_PRODUCT_DATA: state => {
            return state.chartProductData;
        },
        CHART_BRAND_DATA: state => {
            return state.chartBrandData;
        },
        CHART_CATEGORY_DATA: state => {
            return state.chartCategoryData;
        },
        CHART_RU_QUERY_DATA: state => {
            return state.chartRuQueryData;
        },
        CHART_WW_QUERY_DATA: state => {
            return state.chartWwQueryData;
        },

        TABLE_DATA: state => {
            return state.tableData;
        }
    },
    mutations: {
        SORT_FIELD: (state, payload) => {
            return state.sortField = payload;
        },
        SORT_DIR: (state, payload) => {
            return state.sortDir = payload;
        },
        CHART_DICTIONARY_DATA: (state, payload) => {
            return state.chartDictionaryData = payload;
        },
        CHART_IMPORT_DATA: (state, payload) => {
            return state.chartImportData = payload;
        },
        CHART_PRODUCT_DATA: (state, payload) => {
            return state.chartProductData = payload;
        },
        CHART_BRAND_DATA: (state, payload) => {
            return state.chartBrandData = payload;
        },
        CHART_CATEGORY_DATA: (state, payload) => {
            return state.chartCategoryData = payload;
        },
        CHART_RU_QUERY_DATA: (state, payload) => {
            return state.chartRuQueryData = payload;
        },
        CHART_WW_QUERY_DATA: (state, payload) => {
            return state.chartWwQueryData = payload;
        },

        CURRENT_USER: (state, payload) => {
            return state.currentUser = payload;
        },
        SHOW_TYPE: (state, payload) => {
            return state.showType = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
        TABLE_DATA: (state, payload) => {
            return state.tableData = payload;
        }
    },
    actions: {
        GET_USERS: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/users/short',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.usersData;
                    state.users = [];
                    for (let key in data) {
                        state.users.push({
                            value: data[key].id,
                            text: data[key].secondName +' '+ data[key].name,
                        })
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/users/control/'+ state.currentUser +'/'+ state.showType +'?perPage='+ state.perPage
                    +'&currentPage='+ state.currentPage
                    +'&sortField='+ state.sortField
                    +'&sortDir='+ state.sortDir,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data;
                    state.totalRows = data.total
                    state.tableData = data.tableData
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_CHART_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            state.chartDictionaryData = {}
            state.chartImportData = {}
            state.chartProductData = {}
            state.chartBrandData = {}
            state.chartCategoryData = {}
            state.chartRuQueryData = {}
            state.chartWwQueryData = {}

            await payload.th.$store.dispatch('SEND_GET', {
                url: '/users/control/chart/'+ state.currentUser +'/'+ state.showType +'?from='+ payload.th.chartFrom
                    +'&to='+ payload.th.chartTo,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let chart = responseData.data
                    let chartDictionaryData = []
                    let chartImportData = []
                    let chartProductData = []
                    let chartBrandData = []
                    let chartCategoryData = []
                    let chartRuQueryData = []
                    let chartWwQueryData = []
                    for (let key in chart) {
                        chartDictionaryData[key] = chart[key].dictionary
                        chartImportData[key] = chart[key].import
                        chartProductData[key] = chart[key].product
                        chartBrandData[key] = chart[key].brand
                        chartCategoryData[key] = chart[key].category
                        chartRuQueryData[key] = chart[key].ruQuery
                        chartWwQueryData[key] = chart[key].wwQuery
                    }

                    let chartPrepare = function (chartData, name) {
                        let buf = {
                            labels: [],
                            datasets: [{
                                label: name,
                                data: [],
                                borderWidth: 1
                            }]
                        }
                        for (let key in chartData) {
                            buf.labels.push(key);
                            buf.datasets[0].data.push(chartData[key]);
                        }

                        return buf
                    }

                    state.chartDictionaryData = chartPrepare(chartDictionaryData, 'Переводы')
                    state.chartImportData = chartPrepare(chartImportData, 'Импорт')
                    state.chartProductData = chartPrepare(chartProductData, 'Продукты')
                    state.chartBrandData = chartPrepare(chartBrandData, 'Бренды')
                    state.chartCategoryData = chartPrepare(chartCategoryData, 'Категории')
                    state.chartRuQueryData = chartPrepare(chartRuQueryData, 'Запросы (ru)')
                    state.chartWwQueryData = chartPrepare(chartWwQueryData, 'Запросы (ww)')
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },


    }
}